import "./style.css"
import { useEffect, useState } from 'react';
import LoadingBtn from '../../atoms/loadingBtn/view';
import { listener } from '../../../utils/dispatch';
import { lang } from '../../../utils/langs';

function ButtonLoading({ id, title, children, onClick, disabled, style, type = "button", className = "btn-pill btn-pill-primary" }) {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const eventId = id ? `loading-btn-${id}` : 'loading-btn';
        const unbind = listener(eventId, () => { setLoading(false) });
        const unbindGlobal = listener('loading-btn', () => { setLoading(false) });
        return () => {
            if (unbind) unbind();
            if (unbindGlobal) unbindGlobal();
        };
    }, [id]);

    function handleClick() {
        if (type !== "submit") {
            setLoading(true);
            if (onClick) onClick();
        } else if (onClick) {
            onClick();
        }
    }

    return (
        <button
            id={id || "btn-loading"}
            className={`btn-loading ${className}`}
            onClick={handleClick}
            type={type}
            disabled={disabled || loading}
            style={style}
        >
            <LoadingBtn loading={loading}>
                {children}
                {title ? lang('es', title) : null}
            </LoadingBtn>
        </button>
    );
}

export default ButtonLoading;
